import React, { useEffect, useState } from 'react';
import apiRequests from "../../Component/axios/config/config";
import toast from 'react-hot-toast';
import moment from 'moment-jalaali';
import { IoMdSend } from "react-icons/io";
import { IoMdCloseCircle } from "react-icons/io";
import chatbackground from "../../assets/image/chatbackground.jpg"



export default function Poshtibani() {
    const [tickets, setTickets] = useState([]);
    const [loading, setLoading] = useState(false);
    const [selectedTicket, setSelectedTicket] = useState(null);
    const [messages, setMessages] = useState([]);
    const [answer, setAnswer] = useState("");
    const [showChatModal, setShowChatModal] = useState(false);

    useEffect(() => {
        fetchTickets();
    }, []);

    const fetchTickets = () => {
        setLoading(true);
        apiRequests.get("/api/ticket/v1/get-my-ticket-list-admin")
            .then(res => {
                setTickets(res.data.message|| []);
            })
            .catch(() => {
                toast.error("خطا در دریافت تیکت‌ها");
            })
            .finally(() => setLoading(false));
    };

    const formatDate = (date) => {
        if (!date) return "نامشخص";
        return moment(date).format("jYYYY/jMM/jDD HH:mm");
    };

    const handleDelete = (id) => {
        apiRequests.delete("/api/ticket/v1/admin--ticket-list-delete", {
            data: { tickets: [id] }
        })
            .then(() => {
                toast.success("تیکت حذف شد.");
                fetchTickets();
            })
            .catch(() => toast.error("خطا در حذف تیکت"));
    };

    const handleAnswerClick = (ticket) => {
        apiRequests.get(`/api/ticket/v1/get-ticket-messages-admin/${ticket._id}`)
            .then(res => {
                setMessages(res.data.message);
                setSelectedTicket(ticket);
                setShowChatModal(true);
            })
            .catch(() => {
                toast.error("خطا در دریافت پیام‌ها");
            });
    };

    const sendAnswer = () => {
        if (!answer.trim()) return;

        apiRequests.put("/api/ticket/v1/admin-answer-ticket", {
            ticket_id: selectedTicket._id,
            description: answer.trim()
        })
            .then(() => {
                toast.success("پاسخ ارسال شد.");
                setAnswer("");
                handleAnswerClick(selectedTicket); // Refresh messages
            })
            .catch(() => toast.error("ارسال پاسخ با خطا مواجه شد"));
    };

    return (
        <div >
            <div className=" text-3xl mr-8">پشتیبانی</div>

            <div className="flex justify-center ">
                <div className="min-w-[80%] mt-12 ">
                <table className="w-full">
                    <thead className="bg-secondColor-shade4   text-white text-center">
                    <tr>
                        <th className="px-4 py-2 rounded-tr-lg">عنوان</th>
                        <th className="px-4 py-2">شماره</th>
                        <th className="px-4 py-2">ایجاد شده در</th>
                        <th className="px-4 py-2">ویرایش شده در</th>
                        <th className="px-4 py-2 rounded-tl-lg">عملیات</th>
                    </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200 text-center">
                    {loading ? (
                        <tr><td colSpan="5" className="py-6">در حال بارگذاری...</td></tr>
                    ) : tickets.length === 0 ? (
                        <tr><td colSpan="5" className="py-6">تیکتی یافت نشد!</td></tr>
                    ) : (
                        tickets.map((ticket) => (
                            <tr key={ticket._id} className="hover:bg-gray-100">
                                <td className="px-4 py-2">{ticket.subject}</td>
                                <td className="px-4 py-2">{ticket.creator?.user_id?.mobile}</td>
                                <td className="px-4 py-2">{formatDate(ticket.createdAt)}</td>
                                <td className="px-4 py-2">{formatDate(ticket.updatedAt)}</td>
                                <td className="px-4 py-2 flex justify-center gap-3">
                                    <button onClick={() => handleAnswerClick(ticket)} className="text-blue-600 hover:underline">پاسخ</button>
                                    <span>/</span>
                                    <button onClick={() => handleDelete(ticket._id)} className="text-red-600 hover:underline">حذف</button>
                                </td>
                            </tr>
                        ))
                    )}
                    </tbody>
                </table>
                </div>
            </div>

            {showChatModal && (
                <div className="fixed inset-0 backdrop-blur-2xl bg-black bg-opacity-50  z-50 flex justify-center items-center">
                    <div className="bg-white rounded-xl shadow-lg w-full max-w-2xl h-[80vh] flex flex-col relative">
                        <div className="p-4 bg-gray-100 text-black text-lg rounded-t-xl flex justify-between items-center">
                            <span>پاسخ به تیکت:  {selectedTicket?.subject}</span>
                            <button onClick={() => setShowChatModal(false)} className="text-gray-800 hover:text-gray-200 ">
                                <IoMdCloseCircle size={24}/>
                            </button>
                        </div>

                        <div className="flex-1 p-4 overflow-y-auto  space-y-3"
                             style={{ backgroundImage: `url(${chatbackground})` }}>
                            {messages.map((msg) => {
                                const isAdmin = msg.sender?.user_id?._id !== selectedTicket?.creator?.user_id?._id;
                                return (
                                    <div
                                        key={msg._id}npm
                                        className={`max-w-[75%] p-3 rounded-xl shadow text-sm ${isAdmin ? "ml-auto bg-gradient-to-bl from-blue-900 to-gray-600 text-white" : "mr-auto bg-white text-black border"}`}
                                    >
                                        <div>{msg.description}</div>
                                        <div className="text-xs mt-2 text-gray-300 text-left">{formatDate(msg.createdAt)}</div>
                                    </div>
                                );
                            })}
                        </div>

                        <div className="p-4 border-t bg-gray-100  flex gap-2 rounded-b-xl">
                            <button
                                onClick={sendAnswer}
                                className="bg-[#141e66] text-white w-10 h-10 pl-1 flex justify-center items-center rounded-full hover:bg-[#141e99]"
                            >
                                <IoMdSend size={24}/>

                            </button>
                            <input
                                type="text"
                                value={answer}
                                onChange={(e) => setAnswer(e.target.value)}
                                placeholder="پاسخ خود را بنویسید..."
                                className="flex-1 border border-gray-300 rounded-full px-3 py-2"
                            />

                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
